import { render } from "./TheModalContactForm.vue?vue&type=template&id=8d145bf4&scoped=true"
import script from "./TheModalContactForm.vue?vue&type=script&lang=js"
export * from "./TheModalContactForm.vue?vue&type=script&lang=js"

import "./TheModalContactForm.vue?vue&type=style&index=0&id=8d145bf4&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d145bf4"]])

export default __exports__